import React, {useContext, useRef, useState} from 'react';
import IdleTimer from 'react-idle-timer';
import MenuContext from '../../context/menuContext';
import LockScreen from '../lock-screen';

function IdleTimerContainer() {
  const {selected, onComponent, component, setDisableMenu} = useContext(MenuContext);
  const [tempComponent, setTempComponent] = useState();
  const [isLocked, setIsLocked] = useState(false);
  const idleTimerRef = useRef(null);
  const onIdle = () => {
    if (!component) {
      return;
    }
    setDisableMenu(true);
    setIsLocked(true);
    setTempComponent(component);
    onComponent(null);
  };
  const onUnlock = () => {
    setIsLocked(false);
    onComponent(tempComponent);
    setTempComponent(null);
    setDisableMenu(false);
  };
  return (
    <div style={{position: 'absolute', top: 0, left: 0}}>
      {isLocked && <LockScreen onUnlock={onUnlock} />}
      <IdleTimer ref={idleTimerRef} timeout={60 * 1000} onIdle={onIdle}></IdleTimer>
    </div>
  );
}

export default IdleTimerContainer;
